module.exports = __webpack_public_path__ + "static/media/pbdj.55265465.png";